import { useState } from 'react'
import { useChainId } from 'wagmi'

import { createClaimMarketRewardsObjectives } from './createClaimMarketRewardsObjectives'
import { getRewardsToClaim } from './getRewardsToClaim'
import { useSnapshot } from '@/domain/hooks/useSnapshot'
import { Objective } from '@/features/actions/logic/types'
import { useActions } from '@/features/actions/logic/useActions'
import { ActionsViewState } from '@/features/actions/types'
import { PageState, PageStatus } from '@/features/dialogs/common/types'
import { useMarketInfo } from '@/features/sparklend/common/data/market-info/useMarketInfo'
import { Reward } from '@/features/topbar/types'

export interface UseClaimRewardsDialogResult {
  pageStatus: PageStatus
  rewardsToClaim: Reward[]
  objectives: Objective[]
  actionsViewState: ActionsViewState
}

export function useClaimRewardsDialog(): UseClaimRewardsDialogResult {
  const chainId = useChainId()
  const { marketInfo } = useMarketInfo({ chainId })
  const [pageStatus, setPageStatus] = useState<PageState>('form')

  const objectives = createClaimMarketRewardsObjectives(marketInfo)
  const [rewardsToClaim] = useSnapshot(getRewardsToClaim(marketInfo))

  const actionsEnabled = true

  const { viewState: actionsViewState } = useActions({
    objectives,
    context: {
      chainId,
    },
    onFinish: () => setPageStatus('success'),
    enabled: actionsEnabled,
  })

  return {
    pageStatus: {
      state: pageStatus,
      actionsEnabled,
      goToSuccessScreen: () => setPageStatus('success'),
    },
    objectives,
    rewardsToClaim,
    actionsViewState,
  }
}
